<template>
	<div class="customer-forms">
		<ul class="results-list results-list--customer-forms">
			<li
				class="customer-forms__item"
				v-for="form in items"
				:key="form.id"
			>
				<CustomerFormCard :form="form" />
			</li>
		</ul>
	</div>
</template>

<script>
import CustomerFormCard from './customer-forms-card';

export default {
	name: 'CustomerFormList',
	components: {
		CustomerFormCard
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Customer Forms Results List
    * Can use SCSS variables = TRUE
*/
</style>
